import { createApiInstance } from './ApiConfig';

const api = createApiInstance({
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Get paginated list of IMU production information with advanced filtering
 * @param {number} page - Page number (default: 1)
 * @param {number} pageSize - Items per page (default: 50)
 * @param {string} serialNumber - Optional serial number filter
 * @param {Array} jsonFilters - Optional array of {key, value} filters for JSON data
 * @returns {Promise} API response with items and pagination info
 */
export const getImuProductionList = (
  page = 1,
  pageSize = 50,
  serialNumber = '',
  jsonFilters = []
) => {
  const payload = {
    page,
    page_size: pageSize,
  };

  if (serialNumber) {
    payload.serial_number = serialNumber;
  }

  if (jsonFilters && jsonFilters.length > 0) {
    payload.json_filters = jsonFilters;
  }

  return api.post('/imu/production/query_imu_list', payload);
};

/**
 * Get IMU production information by serial number
 * @param {string} serialNumber - Serial number
 * @returns {Promise} API response with production info
 */
export const getImuProductionInfo = serialNumber => {
  return api.get(`/imu/production/${serialNumber}`);
};

/**
 * Create or update IMU production information
 * @param {string} serialNumber - Serial number
 * @param {object} productionData - Production data as JSON object
 * @returns {Promise} API response
 */
export const updateImuProductionInfo = (serialNumber, productionData) => {
  return api.post(`/imu/production/${serialNumber}`, productionData);
};

/**
 * Delete IMU production information
 * @param {string} serialNumber - Serial number
 * @returns {Promise} API response
 */
export const deleteImuProductionInfo = serialNumber => {
  return api.delete(`/imu/production/${serialNumber}`);
};
